/**
 * t446u: the optional Building field in Create a channel (computer, phone web and the app). Same options as the
 * Building choice in Channel settings › About: "No building" first, then the workspace's buildings. The person creating
 * a channel becomes its owner, who may set its building, so everyone who can create a channel gets the field.
 * Opened from a building's page, the form starts on that building.
 */
export const NO_BUILDING_LABEL = 'No building';
export const BUILDING_FIELD_LABEL = 'Building';

export interface BuildingRef { id: string; name: string }

/** "No building", then the buildings in the order the list gives them. */
export function buildingOptions(buildings: readonly BuildingRef[]): { id: string | null; label: string }[] {
  return [{ id: null, label: NO_BUILDING_LABEL }, ...buildings.map(b => ({ id: b.id, label: b.name }))];
}

/** The preset or chosen building if it is still in the list (an archived or unknown one falls back to No building). */
export function initialBuildingChoice(buildings: readonly BuildingRef[] | undefined, id: string | null | undefined): string | null {
  if (!id) return null;
  if (!buildings) return id; // list still loading: keep the preset so the form doesn't flicker
  return buildings.some(b => b.id === id) ? id : null;
}

export function buildingChoiceLabel(buildings: readonly BuildingRef[] | undefined, id: string | null | undefined): string {
  return (id && buildings?.find(b => b.id === id)?.name) || NO_BUILDING_LABEL;
}

/** Body fields for POST /channels: nothing for No building. */
export function buildingCreateFields(id: string | null | undefined): { location_id?: string } {
  return id ? { location_id: id } : {};
}
